<div
  class="d-flex offer-list justify-content-center"
  [class.offer-list--vertical]="computedVariant === 'accordion'"
  [class.offer-list--has-floating-label]="listContainsHighlights()"
  wlAutomationId="commodity-offer-list-offers"
>
  @if (isMijnConsumentEssent()) {
    @if (offersExist()) {
      @for (offer of offers(); track offer.offerId) {
        <essent-consumer-retention-minimal-commodity-offer
          [offer]="offer"
          [variant]="computedVariant"
          [content]="content()"
          [active]="isActive(offer)"
          [ensureHorizontalAlignment]="
            listContainsHighlights() || listContainsIncentives()
          "
          [enableNewOfferCardTitles]="!!content()?.enableNewOfferCardTitles"
          (selectOffer)="selectOffer.emit(offer)"
          (viewTariffs)="viewTariffs.emit(offer)"
          (openMoreInfo)="openMoreInfo.emit(offer)"
        >
        </essent-consumer-retention-minimal-commodity-offer>
      }
    } @else {
      @for (_ of [1, 2, 3]; track _) {
        <essent-consumer-retention-minimal-commodity-offer
          [showLoadingState]="true"
          [variant]="computedVariant"
          [active]="false"
          [enableNewOfferCardTitles]="!!content()?.enableNewOfferCardTitles"
        ></essent-consumer-retention-minimal-commodity-offer>
      }
    }
  }
</div>
